import axios from '@/libs/axios';

const readEndpoint = '/auth/commons/competitionRanks';
const adminEndpoint = '/auth/competition-ranks';

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        async getAll () {
            try {
                return (await axios.get(readEndpoint+'?cacheBust='+(Date.now()).toString())).data || [];
            }
            catch (e) {
                console.log(e);
                return [];
            }
        },
        async getAllWithCounts () {
            try {
                return (await axios.get(adminEndpoint+'?cacheBust='+(Date.now()).toString())).data.data || [];
            }
            catch (e) {
                console.log(e);
                return [];
            }
        },
        async getCompetitions ({}, id) {
            try {
                return (await axios.get(adminEndpoint+'/'+id+'/competitions?cacheBust='+(Date.now()).toString())).data.data || [];
            }
            catch (e) {
                console.log(e);
                return [];
            }
        },
        async create ({}, {rankName, hasJerseyCheck, hasAdditionalReportParameters}) {
            return (await axios.post(adminEndpoint, {
                rankName: rankName,
                hasJerseyCheck: hasJerseyCheck,
                hasAdditionalReportParameters: hasAdditionalReportParameters,
            })).data.data || null;
        },
        async update ({}, {id, rankName, hasJerseyCheck, hasAdditionalReportParameters}) {
            return (await axios.put(adminEndpoint+'/'+id, {
                rankName: rankName,
                hasJerseyCheck: hasJerseyCheck,
                hasAdditionalReportParameters: hasAdditionalReportParameters,
            })).data.data || null;
        },
    },
}
